export async function closeCountingIframe(callback) {
    await (callback === null || callback === void 0 ? void 0 : callback());
    window.parent.postMessage('iframe:close', '*');
}
